import Request from "./Request";

class ClientDataService {
    static async getClientDataForMonth({ clientId, epochMonth, getOnOrderData = false }: { clientId: string|number, epochMonth: number, getOnOrderData?: boolean }) {
        try {
            const params = {
                epochMonth: epochMonth,
                getOnOrderData: getOnOrderData ? 'true' : 'false',
            }
            const response = await Request.get(`/api/clients/${clientId}/month-data`, params);
            return response
        } catch (error) {
            console.error(error);
        }
    }

    static async getClientKpiData({ clientId, startEpochMonth, endEpochMonth, compareToYearsAgo }: { clientId: string|number, startEpochMonth: number, endEpochMonth: number, compareToYearsAgo: number }) {
        try {
            const params = {
                startEpochMonth: startEpochMonth,
                endEpochMonth: endEpochMonth,
                compareToYearsAgo: compareToYearsAgo,
            }
            const response = await Request.get(`/api/clients/${clientId}/kpi-data`, params);
            return response
        } catch (error) {
            console.error(error);
        }
    }

    static async getHealthCashFlowSummary({ clientId, endEpochMonth, locations, locationExclude }: { clientId: string|number, endEpochMonth: number, locations?: string[], locationExclude?: boolean }) {
        try {
            // SPS-5572: location-only filter, serialized the same way
            // PerformanceDashboard.service.applyDashboardFilterParams does — comma-joined
            // `locations`, with `locationsExclude=1` only when excluding. Category/class are
            // intentionally not sent (disabled on this tab — whole-store benchmark).
            const params: Record<string, any> = {
                endEpochMonth: endEpochMonth,
            }
            if (locations && locations.length > 0) {
                params.locations = locations.join(',')
                if (locationExclude) params.locationsExclude = '1'
            }
            const response = await Request.get(`/api/clients/${clientId}/health-cash-flow-summary`, params);
            return response
        } catch (error) {
            console.error(error);
        }
    }

    // SPS-5571: up to `months` trailing-12 health snapshots in ONE call (one row per
    // epochMonthRm), replacing the history modal's N per-month getHealthCashFlowSummary
    // fetches. Each row has the same shape as getHealthCashFlowSummary's `data`, scored
    // in the frontend via the shared pipeline so the modal and card can't disagree.
    static async getHealthScoreHistory({ clientId, endEpochMonth, months = 12, locations, locationExclude }: { clientId: string|number, endEpochMonth: number, months?: number, locations?: string[], locationExclude?: boolean }) {
        try {
            // SPS-5568: location-only filter, serialized exactly like getHealthCashFlowSummary
            // so a card scoped to one store scopes its history series to the same store.
            const params: Record<string, any> = {
                endEpochMonth: endEpochMonth,
                months: months,
            }
            if (locations && locations.length > 0) {
                params.locations = locations.join(',')
                if (locationExclude) params.locationsExclude = '1'
            }
            const response = await Request.get(`/api/clients/${clientId}/health-score-history`, params);
            return response
        } catch (error) {
            console.error(error);
        }
    }

    static async getDataThroughDate({ clientId }: { clientId: string|number }) {
        try {
            const response = await Request.get(`/api/clients/${clientId}/data-through-date`);
            return response;
        } catch (error) {
            console.error(error);
        }
    }

    // RetailORBIT Health Score peer feed (GET /api/indie-insights/health). Supplies the
    // cross-client cohort fields — avg_in_vertical, n_in_vertical, percentile_in_vertical —
    // that only exist once aggregated server-side (null when the cohort is < 4).
    static async getIndieInsightsHealth(clientId: string|number) {
        try {
            const params = {
                client_id: clientId,
            }
            const response = await Request.get(`/api/indie-insights/health`, params);
            return response
        } catch (error) {
            console.error(error);
        }
    }
}

export default ClientDataService;